import { notification } from "antd";
import type { History } from "history";
import { Dispatch } from "react";

import {
    addRunningConfigurableReport,
    getConfigurableReports,
    setCrModalVisibility,
    setCrSelectedItems
} from "../../../Actions/ConfigurableReportActions";
import { IReportReducerState } from "../../../Reducers/ReportsReducer";

const ConfigurableReportingListener = (
    dispatch: Dispatch<any>,
    history: History,
    event: MessageEvent,
    reportState: IReportReducerState,
): void => {
    switch (event.data.type) {
        case "SHOW_CR_MODAL":
            dispatch(setCrModalVisibility(true));
            break;
        case "HIDE_CR_MODAL":
            dispatch(setCrModalVisibility(false));
            dispatch(setCrSelectedItems("[]"));
            if (event.data.success) {
                dispatch(addRunningConfigurableReport());
                notification.success({
                    message: "Success",
                    description: "Configurable Report started",
                    duration: 3,
                });
            }
            break;
        case "INITIATE_CR_MODAL":
            dispatch(setCrModalVisibility(true));
            dispatch(setCrSelectedItems(event.data.selectedItems));
            break;
        case "RETURN_TO_REPORTS_LIST":
            history.push("/reports");
            dispatch(getConfigurableReports(
                reportState.reportsStartDate,
                reportState.reportsEndDate,
                reportState.collaboratingReports,
            ));
            break;
        default:
            break;
    }
};

export default ConfigurableReportingListener;
